import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Search from "@/pages/Search";
import SpaceDetail from "@/pages/SpaceDetail";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import HostDashboard from "@/pages/HostDashboard";
import CreateListing from "@/pages/CreateListing";
import Trips from "@/pages/Trips";
import HowItWorks from "@/pages/HowItWorks";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VerifyIdentity from "@/pages/VerifyIdentity";
import ListYourSpace from "@/pages/ListYourSpace";
import AdminDashboard from "@/pages/AdminDashboard";
import Info from "@/pages/Info";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/search" element={<Search />} />
            <Route path="/spaces/:id" element={<SpaceDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/host" element={<HostDashboard />} />
            <Route path="/host/new" element={<CreateListing />} />
            <Route path="/host/edit/:id" element={<CreateListing />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/verify-identity" element={<VerifyIdentity />} />
            <Route path="/list-your-space" element={<ListYourSpace />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/trust-safety" element={<Info page="trust-safety" />} />
            <Route path="/cancellation" element={<Info page="cancellation" />} />
            <Route path="/terms" element={<Info page="terms" />} />
            <Route path="/privacy" element={<Info page="privacy" />} />
            <Route path="/contact" element={<Info page="contact" />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
